module.exports = __webpack_public_path__ + "static/media/prescription-bottle-alt.a877d6dd.svg";